unit unit_Aktivierung;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, DB, Vcl.Controls, WEBLib.Grids, Vcl.StdCtrls,
  WEBLib.StdCtrls, XData.Web.JsonDataset, XData.Web.Dataset;

type
  TAktivierung = class(TForm)
    TC: TTableControl;
    xdskdppw: TXDataWebDataSet;
    xdskdppwLINKID: TStringField;
    xdskdppwKundennummer: TStringField;
    xdskdppwDatum: TDateTimeField;
    xdskdppwBenutzt: TDateTimeField;
    btnactivation: TButton;
    procedure WebFormShow(Sender: TObject);
    procedure xdskdppwAfterOpen(DataSet: TDataSet);
    procedure btnactivationClick(Sender: TObject);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    btnAktivieren:TButton;
    buttonzurueck:TButton;
    procedure btnAktivierenclick(Sender:TObject);
    procedure buttonzurueckclick(Sender:TObject);
    procedure FormularErstellen;
  protected procedure LoadDFMValues; override; end;

var
  Aktivierung: TAktivierung;
  edtZugangsCode:TEdit;

implementation
  uses unit1, unit2, unit_PasswortVergeben;
{$R *.dfm}

procedure TAktivierung.buttonzurueckclick(Sender:TObject);
begin
  close;
end;

procedure TAktivierung.btnactivationClick(Sender: TObject);
var
  LFrm:TPasswortVergeben;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TPasswortVergeben;
    begin
      LForm:=(AForm as TPasswortVergeben);
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      //nix
    end;
  begin
    LFrm:=TPasswortVergeben.CreateNew(@AfterCreate);
    LFrm.ShowModal(@AfterShowmodal);
end;

procedure TAktivierung.btnAktivierenclick(Sender:TObject);
var
  tmpcode:string;
begin
  if edtZugangsCode.Text='' then
  begin
    showmessage('Sie haben keinen Zugangscode eingegeben');
    exit;
  end;

  if length(edtZugangsCode.Text)<36 then
  begin
    showmessage('Der Zugangscode ist unplausibel/unvollständig');
    exit;
  end;

  tmpcode:=edtZugangsCode.Text;

  xdskdppw.Close;
  xdskdppw.QueryString:='$filter=LINKID eq '+tmpcode;
  xdskdppw.Load;
end;


procedure TAktivierung.FormularErstellen;
var
  myelement:TJSHTMLElement;
  i:integer;
begin

  TC.ColCount:=1;
  TC.RowCount:=5;
  TC.Cells[0,i]:='<h4>Zugang aktivieren';
  inc(i);
  myelement:=TC.cellelements[0,i];
  buttonzurueck:=TButton.Create(self);
  buttonzurueck.ElementClassName:='btn btn-info text-left';
  buttonzurueck.HeightStyle:=ssauto;
  buttonzurueck.WidthStyle:=ssauto;
  buttonzurueck.tag:=0;
  buttonzurueck.Caption:='<< zurück';
  buttonzurueck.OnClick:=@buttonzurueckClick;
  buttonzurueck.ParentElement:=myelement;
  inc(i);

  TC.Cells[0,i]:='<b>Tragen Sie hier den erhaltenen Zugangscode ein und klicken Sie anschließend auf "Aktivieren":</b>';

  inc(i);
  TC.Cells[0,i]:='Ihr Zugangscode (Eingabe zwingend erforderlich) <br>';
  myelement:=TC.CellElements[0,i];
  edtZugangsCode:=TEdit.Create(self);
  edtZugangsCode.ElementClassName:='form-control';
  edtZugangsCode.Width:=400;
  edtZugangsCode.HeightStyle:=ssAuto;
  edtZugangsCode.TextHint:='';
  edtZugangsCode.MaxLength:=36;
  edtZugangsCode.Text:='';
  edtZugangsCode.ParentElement:=myelement;



  inc(i);
  myelement:=TC.cellelements[0,i];
  btnAktivieren:=TButton.Create(self);
  btnAktivieren.ElementClassName:='btn btn-info text-left';
  btnAktivieren.HeightStyle:=ssauto;
  btnAktivieren.WidthStyle:=ssauto;
  btnAktivieren.tag:=0;
  btnAktivieren.Caption:='Aktivieren';
  btnAktivieren.OnClick:=@btnAktivierenClick;
  btnAktivieren.ParentElement:=myelement;

  edtZugangsCode.SetFocus;


end;

procedure TAktivierung.WebFormShow(Sender: TObject);
begin
  FormularErstellen;
end;

procedure TAktivierung.xdskdppwAfterOpen(DataSet: TDataSet);
begin
  if xdskdppw.RecordCount=1 then
  begin
    if xdskdppwDatum.AsDateTime>(date-1) then
    begin
      KundeKundennummer:=xdskdppwKundennummer.AsString;
      self.close;
      btnactivationClick(nil);
    end
    else
    begin
      showmessage('Der eingegebne Aktivierungscode ist bereits abgelaufen');
    end;
  end
  else
  begin
    showmessage('Der eingegebne Aktivierungscode ist nicht gültig');
  end;
end;

procedure TAktivierung.LoadDFMValues;
begin
  inherited LoadDFMValues;

  TC := TTableControl.Create(Self);
  btnactivation := TButton.Create(Self);
  xdskdppw := TXDataWebDataSet.Create(Self);
  xdskdppwLINKID := TStringField.Create(Self);
  xdskdppwKundennummer := TStringField.Create(Self);
  xdskdppwDatum := TDateTimeField.Create(Self);
  xdskdppwBenutzt := TDateTimeField.Create(Self);

  TC.BeforeLoadDFMValues;
  btnactivation.BeforeLoadDFMValues;
  xdskdppw.BeforeLoadDFMValues;
  xdskdppwLINKID.BeforeLoadDFMValues;
  xdskdppwKundennummer.BeforeLoadDFMValues;
  xdskdppwDatum.BeforeLoadDFMValues;
  xdskdppwBenutzt.BeforeLoadDFMValues;
  try
    Name := 'Aktivierung';
    Width := 225;
    Height := 386;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 0;
    TC.Width := 225;
    TC.Height := 386;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 2;
    TC.ColHeader := False;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.WordWrap := True;
    TC.ColCount := 2;
    btnactivation.SetParentComponent(Self);
    btnactivation.Name := 'btnactivation';
    btnactivation.Left := 56;
    btnactivation.Top := 16;
    btnactivation.Width := 96;
    btnactivation.Height := 25;
    btnactivation.Caption := 'btnactivation';
    btnactivation.ChildOrder := 1;
    btnactivation.ElementClassName := 'btn';
    btnactivation.ElementFont := efCSS;
    btnactivation.HeightStyle := ssAuto;
    btnactivation.HeightPercent := 100.000000000000000000;
    btnactivation.Visible := False;
    btnactivation.WidthPercent := 100.000000000000000000;
    SetEvent(btnactivation, Self, 'OnClick', 'btnactivationClick');
    xdskdppw.SetParentComponent(Self);
    xdskdppw.Name := 'xdskdppw';
    xdskdppw.AfterOpen := xdskdppwAfterOpen;
    xdskdppw.EntitySetName := 'KundenportalPasswortVergessen';
    xdskdppw.Connection := DM2.XDataWebConnection1;
    xdskdppw.Left := 37;
    xdskdppw.Top := 19;
    xdskdppwLINKID.SetParentComponent(xdskdppw);
    xdskdppwLINKID.Name := 'xdskdppwLINKID';
    xdskdppwLINKID.FieldName := 'LINKID';
    xdskdppwLINKID.Required := True;
    xdskdppwLINKID.Size := 38;
    xdskdppwKundennummer.SetParentComponent(xdskdppw);
    xdskdppwKundennummer.Name := 'xdskdppwKundennummer';
    xdskdppwKundennummer.FieldName := 'Kundennummer';
    xdskdppwKundennummer.Required := True;
    xdskdppwKundennummer.Size := 13;
    xdskdppwDatum.SetParentComponent(xdskdppw);
    xdskdppwDatum.Name := 'xdskdppwDatum';
    xdskdppwDatum.FieldName := 'Datum';
    xdskdppwDatum.Required := True;
    xdskdppwBenutzt.SetParentComponent(xdskdppw);
    xdskdppwBenutzt.Name := 'xdskdppwBenutzt';
    xdskdppwBenutzt.FieldName := 'Benutzt';
  finally
    TC.AfterLoadDFMValues;
    btnactivation.AfterLoadDFMValues;
    xdskdppw.AfterLoadDFMValues;
    xdskdppwLINKID.AfterLoadDFMValues;
    xdskdppwKundennummer.AfterLoadDFMValues;
    xdskdppwDatum.AfterLoadDFMValues;
    xdskdppwBenutzt.AfterLoadDFMValues;
  end;
end;

end.